import { AnalyticsEvents } from "./AnalyticsEvents";

export default AnalyticsEvents;
